export default "__VITE_ASSET__CAXJLQIA__"